import PrestationFormProduitLiesController from './prestation.form.produit.lies.controller';

export default {
    bindings: {
        prestation: '=',
        isOpen: '='
    },
    template: require('./prestation.form.produit.lies.html'),
    controller: PrestationFormProduitLiesController
};